import { h } from '@atomify/jsx';

type ContainerPosition = 'left' | 'right' | 'middle'; // default is full width
interface ContainerInterface {
    position?: ContainerPosition;
    extraClass?: string;
    children?: NodeList;
    attr?: Object;
    hook?: string;
}

export const Container = ({
    extraClass = '',
    position,
    children,
    attr,
    hook,
}: ContainerInterface) => (
    <div
        {...{ [`js-hook-${hook ? hook : ''}`]: !!hook, ...attr }}
        class={`o-container ${extraClass} ${position ? 'container--' + position : ''}`.trim()}>
        {children}
    </div>
);
